import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openRegisterExtension } from '../redux/registerExtension';
import Button from '../Button';
import analytics from '../lib/analytics';

class LinkButton extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    button: PropTypes.object.isRequired,
    openRegisterExtension: PropTypes.func.isRequired,
  };

  recordRegistrationClick = () => {
    const { event, site, section } = this.props;

    analytics.record(
      'registrationClick',
      {
        event: { id: event.id },
        site: { id: site.id },
        siteSection: { id: section.id },
      },
      event.id,
    );
  };

  handleRegisterExtension = () => {
    const { site, openRegisterExtension } = this.props;

    openRegisterExtension();

    if (site.published) {
      this.recordRegistrationClick();
    }
  };

  render() {
    const { event, site, button, openRegisterExtension, ...other } = this.props;

    if (button.useRegistrationLink && event.registerEnabled) {
      return (
        <Button
          event={event}
          site={site}
          button={button}
          onClick={this.handleRegisterExtension}
          {...other}
        />
      );
    }

    return (
      <Button
        event={event}
        site={site}
        component="a"
        button={button}
        href={button.useRegistrationLink ? event.registrationLink : button.url}
        target="_blank"
        onClick={button.useRegistrationLink && site.published && this.recordRegistrationClick}
        {...other}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openRegisterExtension }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps,
)(LinkButton);



// WEBPACK FOOTER //
// ./src/site-render/src/LinkButton/LinkButton.js